module.exports = __webpack_public_path__ + "img/presentations.b591d97a.svg";